import styled from 'styled-components';
import Select from 'components/Core/Select';

const FiltersContainer = styled.div`
  width: ${({ $isLicensingIndustrySplash }) => ($isLicensingIndustrySplash ? '80%' : 'inherit')};
  margin-bottom: 20px;

  p,
  h6 {
    margin: 0;
  }

  h5 {
    padding-bottom: 10px;
    border-bottom: 1px solid var(--grey-4);
  }

  .downloadable-content-filter--item ~ .downloadable-content-filter--item {
    margin-bottom: 0;
  }

  &.splash-filter {
    .download-splash-filter--content {
      .download-splash-filter--item {
        margin-bottom: 0;
      }
    }
  }

  background: var(--grey-1);
  padding: 40px;

  .download-splash-filter--content {
    .download-splash-filter--item {
      margin-top: 30px;

      .download-splash-filter--name {
        padding-bottom: 12px;
        margin-bottom: 0;

        p {
          font-style: normal;
          font-weight: bold;
          font-size: var(--font-size-20);
          line-height: var(--line-height-120);
          letter-spacing: var(--letter-spacing--0-01);
          color: var(--darkest);
        }
      }

      &:first-child {
        margin-top: 0;
      }
    }

    .download-splash-filter--mobile-apply-filter {
      margin-top: 30px;
    }
  }

  @media (min-width: 992px) {
    margin-right: 70px;
  }

  @media (max-width: 991px) {
    width: ${({ $isLicensingIndustrySplash }) => ($isLicensingIndustrySplash ? '100%' : 'inherit')};
  }

  @media (min-width: 768px) {
    margin-right: 0;

    .download-splash-filter--mobile-header-container {
      display: none;
    }
  }

  @media (max-width: 767px) {
    position: fixed;
    top: 0;
    left: 0;
    z-index: var(--z-downloads-page-mobile-filters);
    height: 100%;
    width: 100vw;
    padding: 120px 20px 20px 20px;
    overflow: scroll;
    background-color: var(--white);

    .download-splash-filter--mobile-header-container {
      z-index: 1000;
      background: var(--white);
      height: 70px;
      position: fixed !important;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      top: 0;
      right: 0;
      width: 100%;
      padding: 20px 30px;
      box-shadow: 0px 3px 10px rgba(11, 26, 33, 0.08) !important;

      .download-splash-filter--header-close {
        cursor: pointer;

        .download-splash-filter--header-close-icon {
          width: 20px;
          height: 20px;
        }
      }

      .download-splash-filter--header-clear-filters {
        cursor: pointer;
      }
    }

    .download-splash-filter--content {
      margin-bottom: 100px;

      .download-splash-filter--item {
        margin-bottom: 40px;

        .download-splash-filter--name {
          padding-bottom: 14px;
          margin-bottom: 0px;

          p {
            font-size: var(--font-size-18);
          }
        }
      }
    }

    .download-splash-filter--mobile-apply-filter {
      position: fixed;
      bottom: 0;
      width: 100%;
      display: flex;
      left: 0;
      background: white;
      justify-content: center;
      padding: 10px 20px;
      border-top: 1px solid var(--grey-3) !important;

      button {
        width: 100%;
      }
    }
  }
`;

const FilterSelect = styled(Select)`
  width: 100%;
`;

const DownloadableContentFiltersContainer = styled.div`
  @media (min-width: 900px) {
    .sidebar-detailed-demo {
      width: 80%;
      margin: 0 auto;
    }
  }

  @media (min-width: 991px) {
    .sidebar-detailed-demo {
      margin: 0;
    }
  }
`;

export { DownloadableContentFiltersContainer, FiltersContainer, FilterSelect };
